import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'; // 2.1引入结构
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/zh-CN'; // 引入中文语言包
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
import './styles/index.css'
Vue.use(VueDirectiveImagePreviewer, {
  zIndex: 9999,  //层级显示
  previewSize: 3 //三倍图
})
Vue.prototype.$baseURL = "https://admin.nxhzy.cn/prod-api";
// 修改"前往"文本
locale.el.pagination.goto = '跳至';
// locale.el.pagination.pageClassifier="页"
Vue.config.productionTip = false
import router from './router'
Vue.use(ElementUI);
Vue.use(router);
//配置axios,设置默认请求接口地址
import axios from 'axios'
axios.defaults.baseURL="https://admin.nxhzy.cn/prod-api"
Vue.prototype.$axios=axios


new Vue({
  el: '#app',
  router,
  render: h => h(App),
})

